var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.visible ? _c('div', {
    ref: "dialog",
    class: _vm.$style.container
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "appear": ""
    }
  }, [_c('div', {
    class: _vm.$style.overlay,
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.handleClose($event);
      }
    }
  })]), _c('transition', {
    attrs: {
      "name": "bottom-animate",
      "appear": ""
    }
  }, [_vm._t("default")], 2)], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }